export const ACTION_GET_STARASSIGNMENT_LIST = "ACTION_GET_STARASSIGNMENT_LIST";
export const ACTION_GET_STARASSIGNMENT_TYPE_CATEGORY = "ACTION_GET_STARASSIGNMENT_TYPE_CATEGORY";
export const ACTION_POST_STARASSIGNMENT_ALL = "ACTION_POST_STARASSIGNMENT_ALL";
export const ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES = "ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES";
export const ACTION_POST_STARASSIGNMENT_INDIVIDUAL = "ACTION_POST_STARASSIGNMENT_INDIVIDUAL";
export const ACTION_GET_CARDSlIST = "ACTION_GET_CARDSlIST";
export const ACTION_GET_STARTYPE_LIST = "ACTION_GET_STARTYPE_LIST";
export const ACTION_GET_LIST_HISTORICAL_TEMPLATE = "ACTION_GET_LIST_HISTORICAL_TEMPLATE";
export const ACTION_DOWNLOAD_TEMPLATE = "ACTION_DOWNLOAD_TEMPLATE";
export const ACTION_POST_TEMPLATE = "ACTION_POST_TEMPLATE";
